// Single source of truth for module keys and their human-readable labels.
// Used by both the super-admin commune form and the commune-agent settings so
// technical keys (vie_scolaire, urgences_sante…) are never shown to users.
export const MODULE_LABELS = {
    core: 'Base',
    actualites: 'Actualités',
    agenda: 'Agenda',
    annuaire: 'Annuaire',
    signalement: 'Signalements',
    demarches: 'Démarches en ligne',
    vie_scolaire: 'Vie scolaire',
    alertes: 'Alertes',
    messagerie: 'Messagerie',
    sondages: 'Sondages',
    projets_citoyens: 'Projets citoyens',
    notifications: 'Notifications',
    urgences_sante: 'Urgences & Santé',
    meteo: 'Météo',
    affichage_legal: 'Affichage légal',
    travaux: 'Travaux',
    donnees: 'Données personnalisées',
};
export function moduleLabel(key) {
    return MODULE_LABELS[key] ?? key;
}
// All modules in display order. 'core' is the always-on base.
// Note: notifications is NOT a toggleable module — push is always available
// (citizens opt out via their own preferences).
export const ALL_MODULES = [
    'core', 'actualites', 'agenda', 'annuaire', 'signalement', 'demarches', 'vie_scolaire',
    'alertes', 'messagerie', 'sondages', 'projets_citoyens',
    'urgences_sante', 'meteo', 'affichage_legal', 'travaux', 'donnees',
];
// Modules a commune agent may toggle ('core' excluded — always on).
export const TOGGLEABLE_MODULES = ALL_MODULES.filter((m) => m !== 'core');
// Modules only the super admin may toggle: hidden from the commune settings.
export const SUPER_ADMIN_ONLY_MODULES = ['affichage_legal', 'donnees'];
// Modules shown in the commune settings.
export const COMMUNE_TOGGLEABLE_MODULES = TOGGLEABLE_MODULES.filter((m) => !SUPER_ADMIN_ONLY_MODULES.includes(m));
